function Logo ({ logoUrl, name, alt }) {
  return (
    logoUrl
      ? <img className="logo with-image" src={logoUrl} alt={alt}/>
      : <div className="logo">{name[0]}</div>
  )
}

export default Logo
